export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-accent-500">
      <div className="px-4 md:px-6 max-w-4xl mx-auto text-center">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/30 text-background-50 text-xs font-bold mb-4">
          <i className="ri-smartphone-line"></i>
          移动端看瓜
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-black text-background-50 mb-4">
          随时随地，吃瓜不停
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-8 max-w-xl mx-auto">
          51吃瓜在线移动客户端支持 iOS 与 Android，高清视频在线播放，流畅不卡顿，热点推送即时触达，不错过任何一条劲爆八卦。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a href="#app" className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 bg-background-50 text-accent-600 font-bold text-sm rounded-xl hover:bg-background-100 transition-all duration-200 shadow-md">
            <i className="ri-apple-fill text-lg"></i>
            iOS 版下载
          </a>
          <a href="#app" className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 bg-background-50/20 text-background-50 font-bold text-sm rounded-xl border-2 border-background-50/40 hover:bg-background-50/30 transition-all duration-200">
            <i className="ri-android-fill text-lg"></i>
            Android 版下载
          </a>
        </div>
        <p className="text-background-50/50 text-xs mt-4">扫码下载或通过应用商店搜索"51吃瓜在线"</p>
      </div>
    </section>
  );
}